import React, {useState} from 'react'
import { Typography } from '@material-ui/core'
import { useIntl } from 'src/common/razzle-platform-translate'
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'
import Slider from '@material-ui/core/Slider'
import { withStyles } from '@material-ui/core/styles'


const PrettoSlider = withStyles({
    root: {
        color: '#19B2C5',
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
        '& span': {
            fontSize: '11px',
            textAlign: 'center',
        },
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
})(Slider)

function RadiusFilter(props) {
    const { handleChange, values } = props
    const [value, setValue] = useState(values.radius || 100)
    const { formatMessage } = useIntl('')
    const { isMobile } = useMobileDetector()

    return (
        <div className="flex flex-col sm:px-8 sm:py-8 w-full sm:w-64">
            {values.locationTerm ? (
                <>
                    <div className="sm:mb-4">
                        <Typography className="sm:text-center ml-4 sm:ml-0" variant="h6">{formatMessage({ id: 'Radius', defaultMessage: 'Radius'})}{value ? `: ${value} ${formatMessage({ id: 'km', defaultMessage: 'km' })}` : ''}</Typography>
                    </div>
                    <PrettoSlider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={1000}
                        name="radius"
                        onChange={(event, value) => {
                            setValue(value)
                        }}
                        onMouseUp={() => {
                            handleChange({ target: { name: 'radius', value } })
                        }}
                        onTouchEnd={(e) => {
                            handleChange({ target: { name: 'radius', value } })
                        }}
                        value={value}
                    />
                </>
            ) : isMobile ? null : (
                <Typography className="sm:text-center p-0" variant="h6">{formatMessage({ id: 'Please type your address first', defaultMessage: 'Please type your address first'})}</Typography>
            )}
        </div>
    )

}

export default RadiusFilter
